import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { ResourceCatalog } from '../../models/policy.model';
import { authToken } from '../../scripts/authentication.script';

export class ApiDigitalAuthResource {
  static apiResponse: ApiResponse

  public static async getCatalog(
    api_key: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      const devCatalog: ResourceCatalog = {
        actions: ['read', 'write', 'delete', 'manage', 'execute', 'share'],
        resources: []
      }
      this.apiResponse = { status: 200, message: 'Success', data: devCatalog }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/company/resources`
      let config: any = { headers: { Authorization: authToken() } }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }
}
